import { Card, Row } from 'antd'
import React from 'react'
import Heading from '../../../component/common/Heading'
import CRUDComponent from '../../../component/common/CRUD-Component'
import CONSTANTS from '../../../util/constant/CONSTANTS'
import { useNavigate } from 'react-router-dom'

const Plan = () => {
    const navigate = useNavigate()
    return (
        <>
            <div>
                <Card>
                    <Heading>Plans</Heading>

                    <Row>
                        <CRUDComponent
                            GET={{
                                API: CONSTANTS.API.Plan.getAll,
                                DataModifier: (res, API, Setrefresh) => {
                                    // console.log(res, "GET ALL ABCD");
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `P${data?.id.toString().padStart(7, "0")}`,
                                            view: {
                                                id: data?.id,
                                                onClick: () => {
                                                    navigate(`/app/plan/sub-plan/${data?.id}`)
                                                }
                                            },
                                            feature: data?.feature?.toString(),
                                            accessibleDevice: data?.accessibleDevice?.toString(),
                                        }
                                    })
                                },
                                column: CONSTANTS.TABLE.PLAN,
                            }}
                            isSearch={true}

                        />
                    </Row>
                </Card>
            </div>

        </>
    )
}

export default Plan